module.exports = __webpack_public_path__ + "static/img/hussar_paas_face.d88ea07.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_paas_face.webp
// module id = C4dY
// module chunks = 0